"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DropdownBox = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/web.timers.js");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames6 = _interopRequireDefault(require("classnames"));
var _createRocket = require("../_utils/createRocket");
var _useOutsideClick2 = require("../_utils/hooks/useOutsideClick");
var _forwardRefWithStatics = require("../_utils/forwardRefWithStatics");
var _keyCode = require("../_utils/keyCode");
var _mergeRefs = require("../_utils/mergeRefs");
var _noop = require("../_utils/noop");
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _Popover = _interopRequireDefault(require("../Popover"));
var _useDelayVisible2 = require("../Popover/useDelayVisible");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// 三角朝向和 placement 位置是相对的
var POSITION_MAP = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left'
};
var DropdownBox = exports.DropdownBox = function DropdownBox(_ref) {
  var className = _ref.className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    children = _ref.children,
    onClick = _ref.onClick,
    _ref$onUpdate = _ref.onUpdate,
    onUpdate = _ref$onUpdate === void 0 ? _noop.noop : _ref$onUpdate,
    type = _ref.type,
    placement = _ref.placement,
    searchable = _ref.searchable;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('dropdown');
  (0, _react.useLayoutEffect)(function () {
    return function () {
      onUpdate();
    };
  }, [children, onUpdate]);
  if (!children) {
    return null;
  }
  var _placement$split = placement.split('-'),
    _placement$split2 = (0, _slicedToArray2.default)(_placement$split, 2),
    basePlacement = _placement$split2[0],
    placementModifier = _placement$split2[1]; // eslint-disable-line prefer-const

  if (basePlacement === 'auto') {
    basePlacement = 'top';
  }
  var focusPosition = POSITION_MAP[basePlacement] || 'bottom';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames6.default)("".concat(prefixCls, "-box"), (0, _defineProperty2.default)({}, "".concat(prefixCls, "-box--").concat(type), !!type), (0, _defineProperty2.default)({}, "".concat(prefixCls, "-box--").concat(focusPosition), !!focusPosition && !!type), (0, _defineProperty2.default)({}, "".concat(prefixCls, "-box--").concat(placementModifier), !!placementModifier && !!type), (0, _defineProperty2.default)({}, "".concat(prefixCls, "-box--searchable"), !!searchable),
    // { [`${prefixCls}-box--adapte`]: adaptable },
    className),
    style: _objectSpread({
      position: 'relative'
    }, style),
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-box__inner")
  }, children));
};
var ClickTrigger = function ClickTrigger(_ref2) {
  var childrenElementRef = _ref2.childrenElementRef,
    overlayElementRef = _ref2.overlayElementRef,
    visible = _ref2.visible,
    setVisible = _ref2.setVisible,
    _ref2$openDelay = _ref2.openDelay,
    openDelay = _ref2$openDelay === void 0 ? 0 : _ref2$openDelay,
    _ref2$closeDelay = _ref2.closeDelay,
    closeDelay = _ref2$closeDelay === void 0 ? 0 : _ref2$closeDelay,
    render = _ref2.render,
    _ref2$onClose = _ref2.onClose,
    onClose = _ref2$onClose === void 0 ? function () {} : _ref2$onClose,
    onOpen = _ref2.onOpen;
  var _useOutsideClick = (0, _useOutsideClick2.useOutsideClick)([childrenElementRef, overlayElementRef]),
    listen = _useOutsideClick.listen,
    ignoreProps = _useOutsideClick.ignoreProps;
  listen(function () {
    if (visible) {
      onClose();
      console.log(visible);
      setVisible(false, closeDelay);
    }
  });
  return render({
    overlayProps: ignoreProps,
    childrenProps: {}
  });
};
var HoverTrigger = function HoverTrigger(_ref3) {
  var visible = _ref3.visible,
    setVisible = _ref3.setVisible,
    _ref3$openDelay = _ref3.openDelay,
    openDelay = _ref3$openDelay === void 0 ? 50 : _ref3$openDelay,
    _ref3$closeDelay = _ref3.closeDelay,
    closeDelay = _ref3$closeDelay === void 0 ? 100 : _ref3$closeDelay,
    render = _ref3.render,
    onClose = _ref3.onClose,
    onOpen = _ref3.onOpen;
  var commonProps = {
    onMouseEnter: function onMouseEnter() {
      setVisible(true, openDelay).then(function (done) {
        return done && !visible && onOpen && onOpen();
      });
    },
    onMouseLeave: function onMouseLeave() {
      setVisible(false, closeDelay).then(function (done) {
        return done && onClose && onClose();
      });
    }
  };
  return render({
    overlayProps: commonProps,
    childrenProps: commonProps
  });
};
var Dropdown = (0, _forwardRefWithStatics.forwardRefWithStatics)(function (props, ref) {
  var _classnames5;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('dropdown');
  var getTypeConfig = function getTypeConfig(prefixClss) {
    return {
      // type  headerClassName
      default: "".concat(prefixClss, "--default"),
      text: "".concat(prefixClss, "--text"),
      // 兼容原有 raw 类型
      raw: null
    };
  };
  var _props$defaultOpen = props.defaultOpen,
    defaultOpen = _props$defaultOpen === void 0 ? false : _props$defaultOpen,
    open = props.open,
    onOpenChange = props.onOpenChange,
    _props$type = props.type,
    type = _props$type === void 0 ? 'default' : _props$type,
    button = props.button,
    size = props.size,
    mSize = props.mSize,
    status = props.status,
    width = props.width,
    _props$placements = props.placements,
    placements = _props$placements === void 0 ? 'bottom-start' : _props$placements,
    _props$placementOffse = props.placementOffset,
    placementOffset = _props$placementOffse === void 0 ? 4 : _props$placementOffse,
    _props$trigger = props.trigger,
    trigger = _props$trigger === void 0 ? 'click' : _props$trigger,
    children = props.children,
    disabled = props.disabled,
    onClick = props.onClick,
    _props$onOpen = props.onOpen,
    onOpen = _props$onOpen === void 0 ? _noop.noop : _props$onOpen,
    _props$onClose = props.onClose,
    onClose = _props$onClose === void 0 ? _noop.noop : _props$onClose,
    _props$onKeyDown = props.onKeyDown,
    _onKeyDown = _props$onKeyDown === void 0 ? _noop.noop : _props$onKeyDown,
    _props$onFocus = props.onFocus,
    onFocus = _props$onFocus === void 0 ? _noop.noop : _props$onFocus,
    _props$clickClose = props.clickClose,
    clickClose = _props$clickClose === void 0 ? true : _props$clickClose,
    _props$closeOnScroll = props.closeOnScroll,
    closeOnScroll = _props$closeOnScroll === void 0 ? true : _props$closeOnScroll,
    escapeWithReference = props.escapeWithReference,
    style = props.style,
    className = props.className,
    boxClassName = props.boxClassName,
    boxSizeSync = props.boxSizeSync,
    updateOnChildrenChange = props.updateOnChildrenChange,
    overlayClassName = props.overlayClassName,
    overlayStyle = props.overlayStyle,
    openDelay = props.openDelay,
    searchable = props.searchable;
  var _props$boxStyle = props.boxStyle,
    boxStyle = _props$boxStyle === void 0 ? {} : _props$boxStyle;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    hover = _useState2[0],
    setHover = _useState2[1];
  var _useDelayVisible = (0, _useDelayVisible2.useDelayVisible)({
      defaultVisible: defaultOpen,
      visible: open,
      onVisibleChange: onOpenChange
    }),
    visible = _useDelayVisible.visible,
    setVisible = _useDelayVisible.setVisible;
  // 是否打开一段时间，防止连续 focus/click 连续两次触发开启导致关闭
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    stayedOpen = _useState4[0],
    setStayedOpen = _useState4[1];
  (0, _react.useEffect)(function () {
    if (visible) {
      setTimeout(function () {
        return setStayedOpen(true);
      }, 150);
    } else {
      setStayedOpen(false);
    }
  }, [visible]);
  var dropdownRef = (0, _react.useRef)(null);
  var _useState5 = (0, _react.useState)(),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    dropdownWidth = _useState6[0],
    setDropdownWidth = _useState6[1];
  var openTimeoutRef = (0, _react.useRef)(null);
  var doOpen = (0, _react.useCallback)(function () {
    if (openDelay) {
      if (openTimeoutRef.current) {
        clearTimeout(openTimeoutRef.current);
      }
      openTimeoutRef.current = setTimeout(onOpen, openDelay);
    } else {
      onOpen();
    }
    setVisible(true, openDelay);
  }, [onOpen, openDelay, setVisible]);
  var close = (0, _react.useCallback)(function () {
    if (openTimeoutRef.current) {
      clearTimeout(openTimeoutRef.current);
    }
    setVisible(false);
    onClose();
  }, [onClose, setVisible]);
  var typeConfig = getTypeConfig(prefixCls);
  var headerClassName = typeConfig[type] || typeConfig.default;
  var boxChildren = (0, _react.useMemo)(function () {
    return typeof children === 'function' ? children === null || children === void 0 ? void 0 : children.call(null, close) : children;
  }, [children, close]);
  (0, _react.useEffect)(function () {
    if (dropdownRef.current) {
      setDropdownWidth(dropdownRef.current.clientWidth);
    }
  }, [button, size]);
  if ((boxSizeSync || width === 'full') && dropdownWidth) {
    boxStyle = _objectSpread(_objectSpread({}, boxStyle), {}, {
      minWidth: dropdownWidth,
      maxWidth: dropdownWidth
    });
  }
  var classes = (0, _classnames6.default)(prefixCls, className, (_classnames5 = {}, (0, _defineProperty2.default)(_classnames5, "size-".concat(size), size && size !== 'default'), (0, _defineProperty2.default)(_classnames5, "m-size-".concat(mSize), mSize && mSize !== 'default'), (0, _defineProperty2.default)(_classnames5, "size-".concat(width, "-width"), width && width !== 'default'), (0, _defineProperty2.default)(_classnames5, 'is-expanded', !!visible), (0, _defineProperty2.default)(_classnames5, 'is-disabled', !!disabled), (0, _defineProperty2.default)(_classnames5, "".concat(status), status), _classnames5));
  var Trigger;
  if (typeof trigger === 'string') {
    Trigger = trigger === 'hover' ? HoverTrigger : ClickTrigger;
  } else {
    Trigger = trigger;
  }
  return /*#__PURE__*/_react.default.createElement(_Popover.default, {
    trigger: disabled ? 'empty' : [Trigger, {
      onClose: onClose,
      onOpen: onOpen
    }],
    visible: visible,
    onVisibleChange: setVisible,
    placement: placements,
    placementOffset: placementOffset,
    closeOnScroll: closeOnScroll,
    escapeWithReference: escapeWithReference,
    overlayClassName: overlayClassName,
    overlayStyle: overlayStyle,
    overlay: function overlay(_ref4) {
      var scheduleUpdate = _ref4.scheduleUpdate,
        placement = _ref4.placement;
      return disabled ? null : /*#__PURE__*/_react.default.createElement(DropdownBox, {
        className: boxClassName,
        style: boxStyle,
        onClick: clickClose ? close : function () {},
        onUpdate: updateOnChildrenChange ? scheduleUpdate : function () {}
        //   adaptable={boxAdaptable}
        ,
        type: type,
        placement: placement || '-',
        searchable: !!searchable
      }, boxChildren);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: (0, _mergeRefs.mergeRefs)(ref, dropdownRef),
    className: classes,
    style: style,
    tabIndex: disabled ? -1 : 0,
    onClick: function onClick(event) {
      event.stopPropagation();
      if (disabled) {
        return;
      }
      if (!visible) {
        doOpen();
        //   setTimeout(() => {
        //     console.log(visible)
        //   }, 0);
      } else if (stayedOpen) {
        onClose();
        setVisible(false);
      }
    },
    onKeyDown: function onKeyDown(event) {
      if (_onKeyDown(event, {
        open: visible
      }) === false) {
        return;
      }
      switch (event.keyCode) {
        case _keyCode.KeyCode.Space:
        case _keyCode.KeyCode.Enter:
          if (!visible) {
            doOpen();
          }
          if (visible) {
            close();
          }
          break;
        case _keyCode.KeyCode.Esc:
          if (visible) {
            close();
          }
          break;
        default:
      }
    },
    onFocus: onFocus,
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    }
  }, type === 'pure' ? button : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames6.default)("".concat(prefixCls, "__header"), headerClassName),
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__value")
  }, button), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__icon")
  }))));
}, {
  Footer: (0, _createRocket.createRocket)('DropdownFooter', 'div.@{prefix}-dropdown-box__footer')
});
var _default = exports.default = Dropdown;